import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import Select from "react-select";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

const SupplierEdit = (props) => {
  let fnYear;
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});
  const [supplierOption, setOptionSupplier] = useState({});
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [itemOption, setOptionItem] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  const [branchOption, setOptionBranch] = useState({});
  const [selectedbranch, setSelectedBranch] = useState({});
  const [clientOption, setOptionClient] = useState({});
  const [selectedClient, setSelectedClient] = useState({});
  const [vechicleOption, setOptionVechicle] = useState({});
  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [selectedCity, setSelectedCity] = useState({});
  const [cityOption, setOptionCity] = useState({});
  const [selectedToCity, setSelectedToCity] = useState({});
  const [challanData, setChallanData] = useState(
    location.state
      ? location.state
      : { pay_date: moment().format("YYYY-MM-DD")}
  );
  const [challanDieselData, setChallanDieselData] = useState(
    location.state
      ? location.state
      : { challan_advance_date: moment().format("YYYY-MM-DD") }
  );
  const [challanAdvanceData, setChallanAdvanceData] = useState(
    location.state
      ? location.state
      : { challan_date: moment().format("YYYY-MM-DD") }
  );
  const [selectedAdvanceBranch, setSelectedAdvanceBranch] = useState({});
  const [branchAdvanceOption, setOptionAdvanceBranch] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const fnYear = await trasportApi.fetchAllActiveFinancialYears();
      const clientRec = await trasportApi.fetchAllDrivers();
      const vechicleRec = await trasportApi.fetchAllVehicles();
      const cityRec = await trasportApi.fetchAllCity();
      const supplierRec = await trasportApi.fetchAllSupplier();

      if (fnYear && fnYear.length) {
        let ar = [];
        fnYear.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });

        const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
        const currentYear = new Date().getFullYear();
        let defaultOption;

        if (currentMonth >= 3) {
          // March is the 3rd month
          defaultOption = ar.find(
            (option) => option.label === `${currentYear}-${currentYear + 1}`
          );
        } else {
          defaultOption = ar.find(
            (option) => option.label === `${currentYear - 1}-${currentYear}`
          );
        }

        if (defaultOption) {
          setSelectedFinancialYear(defaultOption);
          setChallanData({
            ...challanData,
            financial_year_id: defaultOption.value,
          });
        } else if (location?.state) {
          const acc = ar.find(
            (acc) => acc.value === location.state.financial_year_id
          );
          setSelectedFinancialYear(acc);
        }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }

      //Client Api Data.
      if (clientRec && clientRec.length) {
        let ar = [];
        clientRec.forEach((item) => {
          ar.push({ value: item.id, label: item.driver_name });
        });

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.driver_id);
          setSelectedClient(acc);
        }
        setOptionClient(ar);
      } else {
        setOptionClient([]);
      }
      
      //Vechile Api Data.
    if (vechicleRec && vechicleRec.length) {
      let ar = [];
      vechicleRec.forEach((item) => {
        ar.push({ value: item.id, label: item.vehicle_number });
      });

      if (location?.state) {
        const acc = ar.find((acc) => acc.value === location.state.vehicle_id);
        setSelectedVechicle(acc);
      }
      setOptionVechicle(ar);
    } else {
      setOptionVechicle([]);
    }
    }
    
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedChallanData = { ...challanData, [name]: value };
  
    // Validate future date for "pay_date"
    if (name === "pay_date") {
      const selectedDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset today's time for comparison
  
      if (selectedDate > today) {
        alert("Future dates are not allowed.");
        return;
      }
    }
  
    // Parse values for calculations
    const amount = parseFloat(updatedChallanData.payamount || 0);
    const debitAmount = parseFloat(updatedChallanData.debit_amount || 0);
  
    // Calculate and assign balance
    if (amount && !debitAmount) {
      updatedChallanData.paybalance = amount.toFixed(2); // Only amount provided
    } else if (amount && debitAmount) {
      updatedChallanData.paybalance = (amount - debitAmount).toFixed(2); // Both amount and debit_amount provided
    }
  
    // Update the state
    setChallanData(updatedChallanData);
  };
  
 
  

  const handleAdvanceChallanChange = (e) => {};

  const handleAdvanceChallanDesialChange = (e) => {};

  const checkRequiredFields = () => {
    if (
      challanData.client_name &&
      challanData.email &&
      challanData.phone &&
      challanData.city &&
      challanData.address &&
      challanData.financial_year_id &&
      challanData.district &&
      challanData.state &&
      challanData.country &&
      challanData.pincode &&
      challanData.pan_number &&
      challanData.gst_no &&
      challanData.tin_no &&
      challanData.ecc_no
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Driver Ka Hisab",challanData);

    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }
    let result2 = {};

    if (challanData.id) {
      result2 = await trasportApi.saveDriverPayment(challanData);
      if (result2.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record Updated successfully",
        });
        navigate(`/driverpayments/${challanData.id}`, { state: challanData });
      }
    } else {
      // const checkChallanNumber =
      //   await trasportApi.fetchChallanDetailsByChallanNo(
      //     challanData.challan_no
      //   );
      // console.log("checkChallanNumber", checkChallanNumber);

      // if(checkChallanNumber && Object.keys(checkChallanNumber).length > 0){
      //   PubSub.publish('RECORD_ERROR_TOAST', { title: 'Challan Number Already Exist', message: "Challan Number Already Exist" });
      //   return;

      // }
      // console.log("Create Time Item =>",challanData)
      result2 = await trasportApi.createDriverPayment(challanData);
      if (result2?.id) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/driverpayments/${result2.id}`, { state: result2 });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record ERROR",
          message: result2.errors[0].msg,
        });
      }
    }
  };

  const handleCancel = () => {
    if (location.state?.id) {
      navigate("/challans/" + challanData.id, { state: challanData });
    } else {
      navigate("/challans/");
    }
  };

  //FinancialYear
  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setChallanData({ ...challanData, financial_year_id: e.value });
  };

  //Item
  const handleItem = (e) => {
    setSelectedItem(e);
    setChallanData({ ...challanData, item_id: e.value });
  };

  //Client
  const handleClient = async (e) => {
    setSelectedClient(e);
    setChallanData({ ...challanData, driver_id: e.value });
    // // const branchRec = await trasportApi.fetchDriverPaymentByPendingStatus();
    // const invoiceData = await trasportApi.fetchDriverPaymentByPendingStatus(e?.value);
    // if (invoiceData) {
    //   let ar = [];
    //   invoiceData.forEach((item) => {
    //     ar.push({
    //       value: item.id,
    //       label: item.invoice_number,
    //       invoice_amount: item.total_invoice_amount,
    //     });
    //   });

    //   if (location?.state) {
    //     const acc = ar.find((acc) => acc.value === location.state.invoice_id);
    //     setSelectedBranch(acc);
    //     // setSelectedAdvanceBranch(acc2);
    //   }
    //   setOptionBranch(ar);
    //   setOptionAdvanceBranch(ar);
    // } else {
    //   setOptionBranch([]);
    // }
  };

  //Branch
  const handleBranch = (e) => {
    setSelectedBranch(e);
    setChallanData({ ...challanData, invoice_id: e.value });
  };

  //Vehicle
  const handleVehicle = (e) => {
    setSelectedVechicle(e);
    setChallanData({ ...challanData, vehicle_id: e.value });
  };

  //From City
  const handleCity = (e) => {
    setSelectedCity(e);
    setChallanData({ ...challanData, from_station_id: e.label });
  };

  //To City
  const handleToCity = (e) => {
    setSelectedToCity(e);
    setChallanData({ ...challanData, to_station_id: e.label });
  };

  //Advance Diesel Supplier.
  const handleSupplier = (e) => {
    setSelectedSupplier(e);
    setChallanDieselData({ ...challanDieselData, supplier_id: e.value });
  };

  //Challan Advance Branch.
  const handleAdvanceBranch = (e) => {
    setSelectedAdvanceBranch(e);
    setChallanAdvanceData({ ...challanDieselData, branch_id: e.value });
  };

  const handlerAddRow = (e) => {};

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ChallanEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Driver Payment Master</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Date Of Payment
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="pay_date"
                      placeholder="Enter Your Payment Date"
                      value={
                        challanData
                          ? moment(challanData.pay_date).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Driver Name
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Party Name"
                      value={selectedClient}
                      onChange={handleClient}
                      options={clientOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Client Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Vehicle
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Vehicle Name"
                      value={selectedVechicle}
                      onChange={handleVehicle}
                      options={vechicleOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Vehicle Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4} style={{marginLeft : ""}}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="paymentType"
                    >
                      Process Type
                    </Form.Label>
                    <Form.Control
                      as="select"
                      id="paymentType"
                      name="payment_status"
                      className="form-view-label"
                      value={challanData.payment_status || ""}
                      onChange={handleChange}
                    >
                      <option value="">--Select--</option>
                      <option value="Credit">Credit</option>
                      <option value="Debit">Debit</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Amount
                    </Form.Label>
                    ₹{/* (Rs) */}
                    <Form.Control
                      required
                      style={{ marginLeft: "19px", marginTop: "-20px" }}
                      type="number"
                      name="payamount"
                      placeholder="Total Payment Amount"
                      value={challanData.payamount}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                {(challanData.payment_status === "Debit") && (
                  <>
                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="bankName"
                        >
                          Debit Amount
                        </Form.Label>
                        <Form.Control
                          type="text"
                          id="bankName"
                          name="debit_amount"
                          placeholder="Enter Debit Name"
                          value={challanData.debit_amount || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </>
                )}
                               
                <Col lg={4}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Balance
                    </Form.Label>
                    ₹{/* (Rs) */}
                    <Form.Control
                      style={{ marginLeft: "19px", marginTop: "-23px" }}
                      type="number"
                      disabled
                      name="paybalance"
                      placeholder="Blance Amount"
                      value={challanData.paybalance}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>                            
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Remark
                    </Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      name="remark"
                      placeholder="Enter a Remark"
                      value={challanData.remark}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};
export default SupplierEdit;
